import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-download-icon',
  templateUrl: './download-icon.component.svg',
  styleUrls: ['./download-icon.component.css'],
})
export class DownloadIconComponent {}
